import { createFileRoute } from "@tanstack/react-router";
import { Panel } from "~/components/ui/page";
import { CompanySettingsForm } from "~/features/settings/company-form";
import { SavExchangeEmailSetting, SavReasonsSettings, SavReturnAddressSettings } from "~/features/settings/sav-reasons";
import { SettingsIntro, SettingsSection } from "~/features/settings/section";
import { useT } from "~/lib/i18n";

export const Route = createFileRoute("/_app/settings/sav")({ component: SavSettingsPage });

function SavSettingsPage() {
  const t = useT();
  return (
    <div className="flex flex-col gap-5">
      <SettingsIntro text={t("settings.pages.sav.subtitle")} />
      {/* Reasons are saved on their own, apart from the alert delay. */}
      <Panel>
        <SettingsSection title={t("settings.savReasons")} description={t("settings.savReasonsHint")}>
          <SavReasonsSettings />
        </SettingsSection>
      </Panel>
      <Panel>
        <SettingsSection title={t("settings.savReturnAddress")} description={t("settings.savReturnAddressHint")}>
          <SavReturnAddressSettings />
        </SettingsSection>
        <SettingsSection title={t("settings.savExchangeEmailTitle")} description={t("settings.savExchangeEmailHint")}>
          <SavExchangeEmailSetting />
        </SettingsSection>
      </Panel>
      <CompanySettingsForm>
        {({ text }) => (
          <Panel>
            <SettingsSection title={t("settings.savAlert")}>
              <div className="grid gap-4 sm:grid-cols-2">
                {text("savAlertDays", t("company.savAlertDays"), { inputMode: "numeric", hint: t("settings.savAlertHint") })}
              </div>
            </SettingsSection>
          </Panel>
        )}
      </CompanySettingsForm>
    </div>
  );
}
